import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Map as MapIcon, List } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const CATEGORY_COLORS = {
  bars: "#2563EB",
  karaoke: "#9333EA",
  restaurants: "#F97316",
  soirees: "#EC4899",
  activites: "#14B8A6",
  hebergements: "#6366F1",
};

const pinIcon = (color) =>
  L.divIcon({
    className: "gospot-pin",
    html: `<div style="width:20px;height:20px;border-radius:9999px;background:${color};border:3px solid #ffffff;box-shadow:0 2px 8px rgba(15,23,42,0.35)"></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

export const ExplorerMap = ({ markers = [], view, onViewChange, heightClass = "h-[70vh] lg:h-[calc(100vh-8rem)]" }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <div
      data-testid="explorer-map"
      className={`relative overflow-hidden rounded-3xl border border-slate-100 shadow-[0_4px_20px_rgba(15,23,42,0.06)] ${heightClass}`}
    >
      <MapContainer
        center={[46.8139, -71.208]}
        zoom={14}
        scrollWheelZoom={false}
        zoomControl={false}
        attributionControl={false}
        className="h-full w-full"
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <ZoomControl position="bottomright" />
        {markers.map((m) => (
          <Marker key={m.slug} position={[m.lat, m.lng]} icon={pinIcon(CATEGORY_COLORS[m.category_key] || "#2563EB")}>
            <Popup>
              <div
                onClick={() => navigate(`/etablissement/${m.slug}`)}
                style={{ cursor: "pointer", minWidth: 140 }}
              >
                <div style={{ fontWeight: 700, fontSize: 14 }}>{m.name}</div>
                <div style={{ fontSize: 12, color: "#64748B" }}>
                  {t(m.category_label)} • {m.neighborhood}
                </div>
                <div style={{ fontSize: 12, color: "#2563EB", fontWeight: 600, marginTop: 4 }}>{t("Voir la fiche →")}</div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      <div className="absolute right-3 top-3 z-[500] flex rounded-full border border-slate-100 bg-white p-1 shadow-lg">
        <button
          type="button"
          data-testid="view-carte-button"
          onClick={() => onViewChange("carte")}
          className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-semibold transition ${
            view === "carte" ? "bg-[#EFF6FF] text-[#2563EB]" : "text-slate-500 hover:text-slate-800"
          }`}
        >
          <MapIcon className="h-3.5 w-3.5" />
          {t("Carte")}
        </button>
        <button
          type="button"
          data-testid="view-liste-button"
          onClick={() => onViewChange("liste")}
          className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-semibold transition ${
            view === "liste" ? "bg-[#EFF6FF] text-[#2563EB]" : "text-slate-500 hover:text-slate-800"
          }`}
        >
          <List className="h-3.5 w-3.5" />
          {t("Liste")}
        </button>
      </div>
    </div>
  );
};
